export default "__VITE_ASSET__ei74B$HW__"